<template>
    <div>
        <core-form col="1" label-align="left" label-width :editable="true" label-direction="vertical" style="height: 100%; overflow: auto">
    <core-form-item label="个人头像：">
      <modifyFace style="width: 100%; max-width: 500px"></modifyFace>
    </core-form-item>
    <core-form-item  label="个人账号：">
         <Input v-model="$store.state.core.user.username"  style="width: 100%; max-width: 500px"  disabled placeholder="Enter something..." />
    </core-form-item>
    <core-form-item label="昵称：">
         <Input v-model="$store.state.core.user.cnname"  style="width: 100%; max-width: 500px" disabled placeholder="Enter something..." />
    </core-form-item>
  </core-form>
    </div>
</template>
<script>
import modifyFace from "../modifyFace";
export default {
     components: {
    modifyFace,
  },
  mounted () {
      console.log(this.$store);
      
  }
}
</script>